import React from 'react';
import Image from './../../common/image';
import useMain from '../../../hooks/useMain';

const HeaderImage = ({ tab }) => {
	const { theme } = useMain();
	return tab?.headerImage && tab?.active ? (
		<div className='row'>
			<div className='col'>
				<div className='headerImageWrapper mb-4'>
					<Image
						className='myImages headerImage w-100'
						fileName={`headers_${theme}/${tab?.id}.webp`}
					/>

					{/* <Image
						className='myImages headerImageShadow w-100 d-none d-md-block'
						// fileName={`headers/${tab.id === 'home' ? 'home' : 'raw'}.webp`}
						fileName={`headers/${tab.id}.webp`}
					/> */}
				</div>
			</div>
		</div>
	) : null;
};

export default HeaderImage;
